<app-modal-header (closeModal)="close()" />
<app-modal-body>
  <h1 class="fs-5" [innerHTML]="'HOLD_ON' | translate"></h1>
  <p class="mb-0">
    {{ 'SAD_TO_SEE_YOU_GO' | translate }}
  </p>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <div class="d-flex gap-2">
    <button
      class="btn btn-danger rounded-5"
      (click)="delete()"
      [disabled]="
        (isHttpRequestRunning && activeButton === ActiveButton.REMOVE_ACCOUNT) || countDownAccountRemoval >= 1
      "
    >
      @if (isHttpRequestRunning && activeButton === ActiveButton.REMOVE_ACCOUNT) {
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      }
      {{ this.confirmDeleteText }}
    </button>
    <button
      class="btn rounded-5"
      (click)="close()"
      [class.btn-outline-dark]="!isBgDarkMode"
      [class.btn-outline-light]="isBgDarkMode"
    >
      {{ 'NO_GO_BACK' | translate }}
    </button>
  </div>
  @if (errorMessage) {
    <div class="d-flex justify-content-center w-100">
      <span class="text-danger mt-2">{{ errorMessage | translate }}</span>
    </div>
  }
</app-modal-footer>
